var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header",class:{ 'has-error': _vm.hasError }},[_c('span',{staticClass:"pay-total",attrs:{"tabindex":"0","role":"definition"}},[_vm._v("Pay "+_vm._s(_vm.orderTotal))])])])}
var staticRenderFns = []

export { render, staticRenderFns }